import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

//  Replace with your Firebase project config from Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyCk3JSOcoaToCE2VIApkMdzDQEFmmqsCGU",
  authDomain: "aspirant-suite-project.firebaseapp.com",
  projectId: "aspirant-suite-project",
  storageBucket: "aspirant-suite-project.firebasestorage.app",
  messagingSenderId: "283579018618",
  appId: "1:283579018618:web:bcb2e6277e8b0s57f517ac3",
  measurementId: "G-2RETHT94ES"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and export it
export const auth = getAuth(app);

// Initialize Firestore and export it
export const db = getFirestore(app);
